import { createQueryKeys } from '@lukemorales/query-key-factory';
import type {
  BjInfoParams,
  MemberAccountInfoParams,
  MemberCheckIdExitsParams,
  MemberCheckIdParams,
  MemberCheckNickParams,
  MemberFindParams,
  RecoveryIdParams,
} from '@module/apis/client-side/member/type';

export const memberQueryKeys = createQueryKeys('member', {
  authenticateMemberLogin: () => ['authenticateMemberLogin'],
  authenticateMemberLogout: () => ['authenticateMemberLogout'],
  fetchMemberCheckId: (memberCheckIdParams: MemberCheckIdParams) => [memberCheckIdParams],
  fetchMemberCheckNick: (memberCheckNickParams: MemberCheckNickParams) => [memberCheckNickParams],
  addMemberJoin: () => ['addMemberJoin'],
  fetchMemberSocialJoin: () => ['fetchMemberSocialJoin'],
  authenticateMemberLoginInfo: () => ['authenticateMemberLoginInfo'],
  fetchMemberLoginInfo: () => ['loginInfo'],
  fetchMemberCheckIdExits: (memberCheckIdExitsParams: MemberCheckIdExitsParams) => [memberCheckIdExitsParams],
  fetchMemberFindChangePassword: () => ['fetchMemberFindChangePassword'],
  fetchChangePassword: () => ['fetchChangePassword'],
  fetchMemberIdInfo: (memberAccountInfoParams: MemberAccountInfoParams) => [memberAccountInfoParams],
  fetchMemberEditInfo: () => ['memberEditInfo'],
  fetchNickChangeStatus: () => ['nickChangeStatus'],
  fetchDeleteProfile: () => ['deleteProfile'],
  fetchUploadProfile: () => ['uploadProfile'],
  fetchBjInfo: (bjInfoParams: BjInfoParams) => [bjInfoParams],
  fetchEditChannel: () => ['editChannel'],
  fetchEditFanGrade: () => ['editFanGrade'],
  fetchMemberLeave: () => ['fetchMemberLeave'],
  fetchAuthCheck: () => ['fetchAuthCheck'],
  fetchMemberAuth: () => ['fetchMemberAuth'],
  fetchMemberFind: (params: MemberFindParams) => [params],
  fetchRecoveryId: (params: RecoveryIdParams) => [params],
  fetchProtectRecovery: () => ['fetchProtectRecovery'],
  fetchUploadBanner: () => ['fetchUploadChannelBanner'],
  fetchASPRefreshUserInfo: () => ['fetchASPRefreshUserInfo'],
});

// 로그아웃 상태에서는 요청 필요 없는 query keys (로그아웃으로 인한 invalidateQueries 시에 불필요한 요청을 막기 위해 쓰임)
export const INVALIDATION_EXCEPTION_QUERY_KEYS_ON_LOGOUT = ['alarm', 'item', 'caption'];
